import { useEffect, useState } from "react";
import { api, errorMessage } from "../lib/api";
import { romeToday } from "../lib/calendar";

export const BookingTimeStep = ({ venue, prefill, onChoose, onAgenda }) => {
  const [slots, setSlots] = useState([]);
  const [presenters, setPresenters] = useState([]);
  const [selected, setSelected] = useState(prefill?.participantIds || (prefill?.presenterId ? [prefill.presenterId] : []));
  const [date, setDate] = useState(prefill?.date || "");
  const [time, setTime] = useState(prefill?.time || "");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let live = true;
    api.get(`/venues/${venue.id}/booking-options`).then(({ data }) => { if (live) {
      setPresenters(data.presenters); setSelected((current) => current.length ? current : data.presenters.length ? [data.presenters[0].id] : []);
    } }).catch((e) => { if (live) setError(errorMessage(e)); });
    return () => { live = false; };
  }, [venue.id]);
  useEffect(() => {
    if (!selected.length) { setSlots([]); return undefined; }
    let live = true; setLoading(true); setError("");
    api.get(`/venues/${venue.id}/booking-suggestions`, { params: { participants: selected.join(",") } })
      .then(({ data }) => { if (live) setSlots(data.slots); })
      .catch((e) => { if (live) setError(errorMessage(e)); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [venue.id, selected]);
  const toggle = (id) => setSelected((current) => current.includes(id)
    ? current.filter((item) => item !== id) : [...current, id]);
  const slotPayload = (slot) => ({ presenter_id: slot.presenter_id || selected[0],
    presenter_name: presenters.find((item) => item.id === (slot.presenter_id || selected[0]))?.name,
    participant_ids: selected, participant_names: presenters.filter((item) => selected.includes(item.id)).map((item) => item.name),
    date: slot.date, time: slot.time });
  const selectManual = (event) => { event.preventDefault(); if (selected.length) onChoose(slotPayload({ date, time })); };
  return <div className="booking-step" data-testid="booking-time-step">
    <p className="booking-context" data-testid="booking-chosen-venue">Orari liberi per <strong>{venue.name}</strong></p>
    {error && <p role="alert" className="form-error" data-testid="booking-time-error">{error}</p>}
    <fieldset className="participant-picker" data-testid="booking-participants">
      <legend className="section-label">CHI VA ALL'INCONTRO</legend>
      {presenters.map((person) => <label key={person.id} className="participant-option" data-testid={`booking-person-${person.id}`}>
        <input type="checkbox" checked={selected.includes(person.id)} onChange={() => toggle(person.id)}
          data-testid={`booking-person-check-${person.id}`} /> <span>{person.name}</span></label>)}
    </fieldset>
    <div className="booking-slot-list" data-testid="booking-suggestions">{slots.map((slot, index) =>
      <button type="button" key={`${slot.date}-${slot.time}-${index}`} onClick={() => onChoose(slotPayload(slot))}
        data-testid={`booking-suggestion-${index}`}>
        <strong>{new Intl.DateTimeFormat("it-IT", { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" }).format(new Date(`${slot.date}T12:00:00Z`))} · {slot.time}</strong>
        <span>{selected.length} {selected.length === 1 ? "persona" : "persone"} disponibili</span>
        <small>{slot.same_loop ? "◆ STESSO GIRO DI UN ALTRO INCONTRO" : "Fascia libera per tutti"}</small>
      </button>)}
      {!slots.length && !error && !loading && <p className="venue-list-empty" data-testid="booking-no-suggestions">Nessun orario libero per tutti nei prossimi 7 giorni.</p>}
      {loading && <p className="venue-list-empty" data-testid="booking-suggestions-loading">Verifico gli orari…</p>}
    </div>
    <form className="booking-manual" onSubmit={selectManual} data-testid="booking-manual-form">
      <span className="section-label">ALTRO ORARIO</span>
      <div className="booking-pair"><div className="form-field"><label htmlFor="booking-manual-date">DATA</label>
        <input id="booking-manual-date" type="date" min={romeToday()} required value={date} onChange={(e) => setDate(e.target.value)}
          data-testid="booking-date-input" /></div><div className="form-field"><label htmlFor="booking-manual-time">ORA</label>
        <input id="booking-manual-time" type="time" step="900" required value={time} onChange={(e) => setTime(e.target.value)}
          data-testid="booking-time-input" /></div></div>
      <button type="submit" disabled={!selected.length} className="hud-button hud-secondary"
        data-testid="booking-manual-continue">Continua</button>
    </form>
    <button type="button" className="text-action" onClick={onAgenda} data-testid="booking-open-agenda">Altro giorno · apri la settimana ›</button>
  </div>;
};